module.exports = __webpack_public_path__ + "img/404.c0b064d2.svg";